import { Flashcard } from '../types/Flashcard';
import { Vignette } from '../types/Vignette';
import { getDisplayImagesFromContent } from './contentImages';
import { getFlashcardVariants } from './flashcardVariants';
import { getPresentedVignetteContent } from './vignetteVariants';

export const cacheContentImages = async (content: Vignette | Flashcard) => {
  const primaryContent =
    'front' in content && 'back' in content
      ? getFlashcardVariants(content as Flashcard)[0]
      : getPresentedVignetteContent(content as Vignette);

  if (!primaryContent) return;
  const images = getDisplayImagesFromContent(primaryContent);
  const urls = images.map((image) => image.src);
  if (urls.length > 0) preloadImages(urls);
};

export const preloadImages = (array: string[]) => {
  // @ts-expect-error ignore
  if (!preloadImages.list) {
    // @ts-expect-error ignore
    preloadImages.list = [];
  }
  // @ts-expect-error ignore
  const list = preloadImages.list;
  for (let i = 0; i < array.length; i++) {
    const img = new Image();

    img.onload = function () {
      const index = list.indexOf(this);
      if (index !== -1) {
        // remove image from the array once it's loaded
        // for memory consumption reasons
        list.splice(index, 1);
      }
    };

    img.onerror = function () {
      const index = list.indexOf(this);
      if (index !== -1) {
        // failed images must leave the list too, or they leak here forever
        list.splice(index, 1);
      }
    };

    list.push(img);
    img.src = array[i];
  }
};
